import React, { useState } from "react";
import { AiOutlineTwitter, AiOutlineUnorderedList } from "react-icons/ai";
import { BiHeart } from "react-icons/bi";
import { BsGlobe } from "react-icons/bs";
import { FaDiscord, FaEthereum } from "react-icons/fa";
import { TbLayoutGrid } from "react-icons/tb";
import { useLocation } from "react-router-dom";
import "../../style/ArtistDetail.css";
import ArtistCollectionGrid from "./ArtistCollectionGrid";

function ArtistDetailPage() {
  const location = useLocation();

  const [artistGrid, setArtistGrid] = useState("grid");

  const datas = [
    {
      mainImg: "image 32.png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
      profileName: "Bubblegoose",
    },
    {
      mainImg: "image 32 (1).png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
      profileName: "DeGods",
    },
    {
      mainImg: "image 32 (2).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
      profileName: "ApeYachtClub",
    },
    {
      mainImg: "image 32 (3).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
      profileName: "Midnight Panthers",
    },
    {
      mainImg: "image11.png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
      profileName: "Bubblegoose",
    },
    {
      mainImg: "hhh.png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
      profileName: "DeGods",
    },
    {
      mainImg: "image 32 (6).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
      profileName: "ApeYachtClub",
    },
    {
      mainImg: "image 32 (7).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
      profileName: "Midnight Panthers",
    },
    {
      mainImg: "image 32 (8).png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
      profileName: "Bubblegoose",
    },
    {
      mainImg: "image 32 (9).png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
      profileName: "DeGods",
    },
    {
      mainImg: "image 32 (10).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
      profileName: "ApeYachtClub",
    },
    {
      mainImg: "image 32 (11).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
      profileName: "Midnight Panthers",
    },
    {
      mainImg: "image 32 (12).png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
      profileName: "Bubblegoose",
    },
    {
      mainImg: "image 32 (13).png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
      profileName: "DeGods",
    },
    {
      mainImg: "image 32 (14).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
      profileName: "ApeYachtClub",
    },
    {
      mainImg: "image 32 (15).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
      profileName: "Midnight Panthers",
    },
  ];

  return (
    <section>
      <div className="pt-sm-5 pt-3">
        <div className="backprofile ">
          <img src="Rectangle 118.png" alt="backDp" className="backDp" />
          {/* <div className="main"> */}

          <img
            src={location.state.id.profileImg}
            alt="profile"
            className="artistProfile"
          />
          {/* </div> */}
        </div>
        <div className="mainContainer">
          <div className="createdSection">
            <div className="d-flex  flex-column">
              <div className="d-flex align-items-center">
                <h2>{location.state.id.profileName}</h2>
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </div>
              <div>
                <p className="createdBy">
                  <span className="opacity-50">Created by</span>{" "}
                  <span>{location.state.id.profileName}</span>
                </p>
              </div>
            </div>
            <div className="d-flex gap-2">
              <div className="iconClass">
                <AiOutlineTwitter />
              </div>
              <div className="iconClass">
                <FaDiscord />{" "}
              </div>
              <div className="iconClass">
                <BsGlobe />
              </div>
            </div>
          </div>
          <p className="return">
            Surprise, adventure, and access to a new world await the holder.
            Return here 6.22. There's a story growing...
          </p>

          <div className="ownedSection mt-4">
            <div className="innerDetails">
              <h2>100</h2>
              <p>items</p>
            </div>
            <div className="innerDetails">
              <h2>70</h2>
              <p>Owned</p>
            </div>
            <div className="innerDetails">
              <h2>
                <FaEthereum /> o.oo5
              </h2>
              <p>Floor price</p>
            </div>
            <div className="innerDetails">
              <h2>
                <FaEthereum /> 3.5k
              </h2>
              <p>Total Volume</p>
            </div>
          </div>

          <div className="d-flex justify-content-between collectionDetailbox mt-sm-4 mt-2 mb-2">
            <div className="d-flex">
              {/* <div className="filterimg"> */}
                {/* <img src="filter-list 1.png" alt="filter" className="d-md-none"/> */}
                <div className="dropdown d-md-block">
                  <button
                    className="dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="false"
                    // aria-expanded="inside"
                  >
                    <img src="filter-list 1.png" alt="filter" />
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a className="dropdown-item" href="#">
                      All caltegories
                    </a>
                    <a className="dropdown-item" href="#">
                      Featured Collection
                    </a>
                    <a className="dropdown-item" href="#">
                      Top artists
                    </a>
                    <a className="dropdown-item" href="#">
                      recommended Collection
                    </a>
                  </div>
                </div>
              {/* </div> */}
              <div className="searchCollection">
                <img src="search (1).png" alt="search" />
                <input
                  type="search"
                  placeholder="Search Collections and Creators"
                />
              </div>
            </div>
            <div className="d-flex ">
              <div className="dropdown ">
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                  // aria-expanded="inside"
                >
                  Recently{" "}
                  <span>
                    <img
                      src="Vector (10).png"
                      alt="arrow"
                      className="mb-1 ms-3"
                    />
                  </span>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a className="dropdown-item" href="#">
                    All caltegories
                  </a>
                  <a className="dropdown-item" href="#">
                    Featured Collection
                  </a>
                  <a className="dropdown-item" href="#">
                    Top artists
                  </a>
                  <a className="dropdown-item" href="#">
                    recommended Collection
                  </a>
                </div>
              </div>

              <div className="listGrid">
                <div
                  className={`iconHolder ${
                    artistGrid === "grid" ? "listActive" : ""
                  }`}
                  onClick={() => setArtistGrid("grid")}
                >
                  <TbLayoutGrid />
                </div>
                <div
                  className={`iconHolder ${
                    artistGrid === "grid" ? "" : "listActive"
                  }`}
                  onClick={() => setArtistGrid("list")}
                >
                  <AiOutlineUnorderedList />
                </div>
              </div>
            </div>
          </div>

          <div>
            {artistGrid === "grid" ? (
              <ArtistCollectionGrid datas={datas} location={location} />
            ) : (
              <div>{/* <UpcomingListView datas={datas} /> */}</div>
            )}
          </div>

          <div className="artistCollection pt-4">
            {/* <div className="artistCollectionCard">
              <div className="artistContainer">
                <img src="image 32.png" alt="creation" className="mainImg" />
                <div className="heartLike">
                  <BiHeart /> <span className="ms-2">5</span>
                </div>
              </div>
              <h5 className="pt-4 d-flex align-items-center">
                Bubblegoose
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </h5>
              <p className="numberCards pt-1">Bubblegoose #234</p>
              <div className="priceofCollection">
                <div className="d-flex opacity-50 bids">
                  <div className="w-50 ">Price</div>
                  <div>Highest bid</div>
                </div>
                <div className="d-flex bidAMounts ">
                  <div className="w-50 ">16.5 ETH</div>
                  <div>10.5 ETH</div>
                </div>
              </div>
              <button className="mt-3 buyNowandbid">BUY NOW</button>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ArtistDetailPage;
